import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { debounce } from "lodash"
import { isNil } from "ramda"

import Button from "@cirrus/legacy/app-components/buttons/button/index.jsx"
import styles from "./content.less"

const isDescendant = (parent, child) => {
  let node = child.parentNode

  while (node !== null) {
    if (node === parent) return true
    node = node.parentNode
  }

  return false
}

class Content extends C {
  static propTypes = {
    actions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
    position: PropTypes.string,
    isSmartPositionCalculation: PropTypes.bool,
    isBackgroundTransparent: PropTypes.bool,
  }

  static defaultProps = {
    actions: [],
    position: "left",
    isSmartPositionCalculation: false,
    isBackgroundTransparent: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      top: 0,
      left: 0,
      right: 0,
      isScrollbarFixed: false,
    }

    this._onWindowClick = (e) => {
      if (e.defaultPrevented) {
        return
      }

      var el = this._containerRef
      if (el !== e.target && !this.isDescendant(el, e.target)) {
        this.close(e)
      }
    }
  }

  showScrollbar() {
    var windowHeight = window.innerHeight

    if (windowHeight < document.body.scrollHeight && !this.state.isScrollbarFixed) {
      this.props.fixScrollbar
        ? this.props.fixScrollbar("add")
        : App.vent.trigger("fixedScrollbar", "add")
      this.setState({
        isScrollbarFixed: true,
      })
    }
  }

  hideScrollbar() {
    this.props.fixScrollbar
      ? this.props.fixScrollbar("remove")
      : App.vent.trigger("fixedScrollbar", "remove")
  }

  isDescendant(parent, child) {
    let node = child
    if (this.closeIcon == child && this.refs.actions == child) {
      return true
    }

    while (node !== null) {
      if (node === parent) {
        return true
      }

      node = node.parentNode
    }

    return false
  }

  close() {
    this.props.close && this.props.close()
  }

  componentDidMount() {
    window.addEventListener("click", this.onClickAway, true)

    window.addEventListener("click", this._onWindowClick)
    window.addEventListener("resize", this.onResizeDebounced)
    this.showScrollbar()
    this.props.isSmartPositionCalculation && this.calculatePosition()
  }

  componentDidUpdate() {
    this.props.isSmartPositionCalculation && this.calculatePosition()
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.onClickAway, true)

    window.removeEventListener("click", this._onWindowClick)
    window.removeEventListener("resize", this.onResizeDebounced)
    this.hideScrollbar()
  }

  getAncorRef() {
    if (!isNil(this.props.ancorRef)) {
      return this.props.ancorRef
    }

    if (!isNil(this.props.getAncorRef)) {
      return this.props.getAncorRef()
    }

    return null
  }

  onClickAway = (event) => {
    if (event.defaultPrevented) {
      return
    }

    if (isNil(this.props.onClose)) {
      return
    }

    const el = this._containerRef
    const anchorEl = this.getAncorRef()
    if (
      event.target !== el &&
      !isDescendant(el, event.target) &&
      (isNil(anchorEl) || !$(event.target).closest(anchorEl).length)
    ) {
      this.props.onClose(event)
    }
  }

  onResizeDebounced = debounce(() => {
    this.showScrollbar()
    this.props.isSmartPositionCalculation && this.calculatePosition()
  })

  calculatePosition() {
    const anchorEl = this.getAncorRef()

    if (isNil(anchorEl)) {
      return
    }

    const anchorBounds = anchorEl.getBoundingClientRect()
    const anchorBoundsBottom = Math.floor(anchorBounds.bottom)

    if (this.state.top !== anchorBoundsBottom) {
      this.setState({
        top: anchorBoundsBottom,
      })
    }

    if (this.props.position === "left") {
      const anchorBoundsLeft = Math.floor(anchorBounds.left)

      if (this.state.left !== anchorBoundsLeft) {
        this.setState({
          left: anchorBoundsLeft,
        })
      }
    }

    if (this.props.position === "right") {
      const documentClientWidth = Math.floor(document.documentElement.clientWidth)
      const anchorBoundsRight = Math.floor(anchorBounds.right)

      if (this.state.right !== documentClientWidth - anchorBoundsRight) {
        this.setState({
          right: documentClientWidth - anchorBoundsRight,
        })
      }
    }
  }

  setContainerRef = (containerRef) => {
    this._containerRef = containerRef
  }

  render() {
    let { actions, contentDisabled, classNameDialog, disabled, className, children } = this.props

    let _this = this
    let backgroundDialog = classNames(styles.backgroundDialog, contentDisabled ? "disabled" : null)
    let containerForScroll = classNames(
      styles.containerForScroll,
      classNameDialog,
      "control-dialog-notification-fix",
      { [styles.scrollbarFixed]: !this.props.isSmartPositionCalculation },
    )

    if (actions.map) {
      actions = actions.map((action, index) => (
        <span key={index} onClick={action.props.disabled ? null : _this.close.bind(_this)}>
          {action}
        </span>
      ))
    }

    let scrollContainerLeft
    let scrollContainerRight
    if (this.props.isSmartPositionCalculation && this.props.position === "right") {
      scrollContainerLeft = "auto"
      scrollContainerRight = `${this.state.right}px`
    } else if (this.props.isSmartPositionCalculation && this.props.position === "left") {
      scrollContainerLeft = `${this.state.left}px`
      scrollContainerRight = "auto"
    } else {
      scrollContainerLeft = null
      scrollContainerRight = null
    }

    let containerLeft
    let containerRight
    if (this.props.isSmartPositionCalculation && this.props.position === "right") {
      containerLeft = "auto"
      containerRight = "0"
    } else if (this.props.isSmartPositionCalculation && this.props.position === "left") {
      containerLeft = "0"
      containerRight = "auto"
    } else {
      containerLeft = null
      containerRight = null
    }

    return (
      <div
        className={classNames(backgroundDialog, {
          [styles.backgroundDialogTransparent]: this.props.isBackgroundTransparent,
        })}>
        <div
          className={containerForScroll}
          style={{
            width: this.props.isSmartPositionCalculation ? `auto` : null,
            top: this.props.isSmartPositionCalculation ? `${this.state.top}px` : null,
            left: scrollContainerLeft,
            right: scrollContainerRight,
          }}>
          <div
            ref={this.setContainerRef}
            className={classNames(styles.container, className, styles.containerFixed)}
            onClick={(e) => {
              this.props.onClick && this.props.onClick(e)
            }}
            style={{
              position: this.props.isSmartPositionCalculation ? "relative" : null,
              left: containerLeft,
              right: containerRight,
            }}>
            <Button
              className={classNames(styles.closeButton, "icon", "icon-cross")}
              getButton={(button) => (this.closeIcon = button)}
              tabIndex={1001}
              onClick={(e) => {
                this.close(e)
                this.props.onCloseButtonClick && this.props.onCloseButtonClick(e)
                this.props.onClose && this.props.onClose(e)
              }}
            />
            {children}
            {actions.length > 0 && (
              <div className={styles.actions} ref="actions">
                {actions}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default Content
